<template>
    <div v-if="datas">
        <div class="response-content table-responsive my-5"  v-model="datas">
            <table class="table table-striped mb-5" v-for="station in datas">
                <thead>
                    <tr>
                        <th :colspan="station.labels.length" scope="col">{{station.name}}</th>
                    </tr>
                </thead>
                <tbody class="tbody">
                    <tr class="table-date">
                        <td v-for="label in station.labels">
                            <span class="d-block">{{label.name}}</span>
                        </td>
                    </tr>
                    <tr class="limit">
                        <td v-for="label in station.labels">
                            <span class="d-block">{{label.limit}}</span>
                        </td>
                    </tr>
                    <tr v-for="date in station.dates">
                        <td v-for="item in date">
                            {{item}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="form-row justify-content-center" v-if="datas" v-for="url in datas">
            <div class="buttons" v-if="url.csvUrl">
                <a :href="url.csvUrl" download class="btn btn-primary">
                    <span>{{$t('omsz.buttons.csv_download')}}</span>
                    <i class="icon icon-arrow-right"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'automatic-table',
    props: {
        datas: {
            type: Array,
            required: true
        }
    },
    data () {
        return {}
    },
}
</script>
